import 'nodelist-foreach-polyfill';
import {serialize} from "form-serialization";
import formatDate from "../utils/formatter-date";
import extend from "extend";

/**
 * 
 * @param {String} selector 
 * @param {Object} options 
 */
const Booking = function(options) {
  var defaults = {
    el: null,

    // 'form' | 'attr' | 'custom'
    mode: 'form',

    // If {mode} is set to 'attr', value of {elAttr} is the attribute of {el} that will be update
    elAttr: 'href',

    // baseURL สามารถเปลี่ยนได้ ถ้าโรงแรมมี custom url ของตัวเอง
    baseURL: 'https://reservation.travelanium.net/propertyibe2/',

    // ค่า default ของฟอร์ม หากฟอร์มไม่มีค่าเหล่านี้เซ็ตเอาไว้ ค่าเหล่านี้จะถูกเพิ่มเข้าไปอัปตโนมัติ
    params: {
      propertyId: null,
      onlineId: 4,
      checkin: formatDate(new Date()),
      checkout: formatDate(new Date().getTime() + 1000*60*60*24),
      lang: null,
      numofadult: 2,
      numofchild: 0,
      numofroom: 1,
      accesscode: null
    },

    render: function() {}
  }

  var methods = {
    defs: defaults,
    opts: extend(true, {}, defaults, options),

    init() {
      switch (this.opts.mode) {
        case 'form':
          if (this.opts.el === null) {
            console.error(`attribute 'el' must be set`);
            return;
          }

          var $el = document.querySelectorAll(this.opts.el);
          $el.forEach(element => {
            element.addEventListener('submit', event => {
              event.preventDefault();
              var formObj = serialize(element, {hash:true});
              var url = this.renderURL(formObj);
              window.open(url, '_blank');
            });
          });
          break;

        case 'attr':
          if (this.opts.el === null) {
            console.error(`attribute 'el' must be set`);
            return;
          }

          var $el = document.querySelectorAll(this.opts.el);
          $el.forEach(element => {
            var DATA = !!element.dataset ? element.dataset : {};
            var DATAOBJ = {};

            for (const key in DATA) {
              if (DATA.hasOwnProperty(key)) {
                const value = DATA[key];
                if (key.indexOf('booking', 0) === 0) {
                  var param = key.slice(7);
                  var firstLetter = param.charAt(0).toLowerCase();
                  param = firstLetter + param.slice(1);
                  DATAOBJ[param] = value;
                }
              }
            }

            var url = this.renderURL(DATAOBJ);
            element.setAttribute('href', url);
          });
          break;

        case 'custom':
          var url = this.renderURL();
          this.opts.render(url, this.opts);
      }
    },

    update(prop, val) {
      this.opts.params[prop] = val;
      this.init();
    },

    renderURL(formParams) {
      var params = extend(true, {}, this.opts.params, formParams);
      var url = this.opts.baseURL;
      
      for (const key in params) {
        var conj = url.indexOf('?') < 0 ? '?' : '&';
        
        if (params.hasOwnProperty(key)) {
          const value = params[key];
          if (!!value) {
            url += conj + key + '=' + value;
          }
        }
      }

      return url;
    }
  }

  methods.init();
  
  return methods;
};

if (typeof window.Booking === 'undefined') {
  window.Booking = Booking;
}

if (typeof window.jQuery !== 'undefined') {
  jQuery.Booking = function(options) {
    return new Booking(options);
  };
}

export default Booking;